//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { analytics } from "/src/main.js";
export default {
  name: "App",
  watch: {
    $route() {
      var classKey = this.$route.params.id;
      var lessonId = this.$route.params.lessonid;
      this.changeLesson(lessonId);
      analytics.logEvent("screen_view", {
        firebase_screen: `/classes/${classKey}/${lessonId}`,
        firebase_screen_class: "screenClass",
      });
    },
    loaded(val) {
      if (val === true) {
        this.$nextTick(() => {
          // console.log(this.$refs.container);
          // this.$refs.container.scrollIntoView({
          //   block: "start",
          //   inline: "nearest",
          // });
        });
      }
    },
  },
  data() {
    return {
      loaded: false,
      currentTab: "Lessons",
    };
  },
  computed: {
    instructor() {
      if (this.loaded) {
        if ("instructor" in this.$store.state.currentLesson)
          return this.$store.state.instructors[
            this.$store.state.currentLesson.instructor
          ];
        else if ("instructor" in this.$store.state.currentClass)
          return this.$store.state.instructors[
            this.$store.state.currentClass.instructor
          ];
        else
          return {
            name: "none",
            picURL: "",
            description: "none",
            website: "none",
          };
      }
      return null;
    },
  },
  methods: {
    changeLesson(idx) {
      this.$store.dispatch("setLessonByIndex", idx);
      this.$store.dispatch("setAnnotationsCurrentKeys");
    },
  },
  async created() {
    var classKey = this.$route.params.id;
    var lessonId = this.$route.params.lessonid;
    this.$store.dispatch("setClassByKey", classKey);
    await this.$store.dispatch("setLessonsByClassKey", classKey);
    this.$store.dispatch("setLessonByIndex", lessonId);
    this.$store.dispatch("setAnnotationsCurrentKeys");
    await this.$store.dispatch("setInstructors");
    this.loaded = true;
    analytics.logEvent("screen_view", {
      firebase_screen: `/classes/${classKey}/${lessonId}`,
      firebase_screen_class: "screenClass",
    });
  },
  mounted() {},
};
